import React from 'react';
import { Link } from 'react-router-dom';
import { Product } from '../../types/content';
import { formatPriceRange } from '../../utils/price';
type FeaturedProductCardProps = {
  product: Product;
};

/** Matches the original home-page shop tile: cut-out photo that cross-fades to a second photo on hover. */
export function FeaturedProductCard({
  product
}: FeaturedProductCardProps) {
  const price = formatPriceRange(product)?.replace(' – ', '-');
  return <Link to={`/product/${product.slug}`} className="group block" data-id="element-207" data-mp="327597keab3mh">
      <div className="relative aspect-[330/288] overflow-hidden" data-id="element-208" data-mp="2x8vcv6gtpwza">
        {product.image && <img src={product.image} alt={product.name} loading="lazy" className={`absolute inset-0 h-full w-full object-contain transition-opacity duration-300 ease-out ${product.hoverImage ? 'group-hover:opacity-0' : ''}`} data-id="element-209" data-mp="2t9d4192a1cct" />}
        {product.hoverImage && <img src={product.hoverImage} alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-300 ease-out group-hover:opacity-100" data-id="element-210" data-mp="344a4zkp7myvd" />}
      </div>
      <h3 className="mt-5 text-[15px] font-medium leading-snug text-white" data-id="element-211" data-mp="301x0ezm79706">{product.name}</h3>
      {price && <p className="mt-4 text-2xl font-medium text-white" data-id="element-212" data-mp="3nrhn9tlh4oeq">{price}</p>}
    </Link>;
}